import { Box } from '@mui/material';
import React from 'react';

const Whitespace = () => {
    return <Box dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />;
};

export default Whitespace;
